export const GALLERY_UPLOADER_CONSTS = {
  fillRequiredFields: 'Заполните обязательные поля',
  galleryUrl: 'Ссылка на галерею',
  imagesCountLimit: 100,
  incorrectLinkMsg: 'Некорректная ссылка',
  photoStoreHttp: 'http://ps.ura.news/gallery/',
  photoStoreHttps: 'https://ps.ura.news/gallery/'
}
